import { Stack, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import Text from '../text';
import Icon from '../icon';
import useDrawer from '@/hooks/use-drawer.hook';
import MoreMenu from '@/components/more-menu';

interface Props {
  children: ReactNode;
  onClose: () => void;
  menu?: ReactNode;
  isTopDrawer?: boolean;
  hideMenu?: boolean;
}

const useStyles = createUseStyles((theme: Theme) => ({
  header: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  icon: {
    padding: 2,
    '&:hover': {
      backgroundColor: theme.palette.lightGray,
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

const DrawerHeader: FC<Props> = ({
  children,
  onClose,
  menu: MenuEl,
  isTopDrawer = false,
  hideMenu = false,
}) => {
  const styles = useStyles();
  const { goBackDrawer } = useDrawer();

  const handleBack = () => {
    goBackDrawer();
  };

  const hasDefaultMenu = !MenuEl;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      className={styles.header}
      px={2.5}
      pb={1.5}
    >
      <Stack maxWidth={450} direction="row" alignItems="center" gap={1}>
        {isTopDrawer && <Icon name="arrow-left" onClick={() => handleBack()} />}
        <Text size="large" dotdot>
          {children}
        </Text>
        {hideMenu ? undefined : hasDefaultMenu ? <MoreMenu menuId="default-menu" /> : MenuEl}
      </Stack>
      <Stack direction="row" alignItems="center" gap={1}>
        <Icon name="close" onClick={() => onClose()} className={styles.icon} />
      </Stack>
    </Stack>
  );
};

export default DrawerHeader;
